export const TRAVEL_UG_INSURANCE_FORM = 'travelUg/quoteForm/';
export const TRAVEL_UG_INSURANCE_FORM_SET_VALUE = TRAVEL_UG_INSURANCE_FORM + 'setValue';
export const TRAVEL_UG_INSURANCE_FORM_SET_VALID = TRAVEL_UG_INSURANCE_FORM + 'setValid';
export const REINITIALIZE = TRAVEL_UG_INSURANCE_FORM + '/state/reinitialize';
export const FORM_VALID_TRAVEL_UG_INSURANCE_FORM = TRAVEL_UG_INSURANCE_FORM + 'formValid';
export const FORM_INVALID_TRAVEL_UG_INSURANCE_FORM = TRAVEL_UG_INSURANCE_FORM + 'formInValid';
export const FORM_VALID_TRAVEL_UG_INSURANCE_QUOTE_SHARE_FORM = TRAVEL_UG_INSURANCE_FORM + 'shareFormValid';
export const FORM_INVALID_TRAVEL_UG_INSURANCE_QUOTE_SHARE_FORM = TRAVEL_UG_INSURANCE_FORM + 'shareFormValid';

export const SET_SHARE_EMAIL_VALUE = TRAVEL_UG_INSURANCE_FORM_SET_VALUE + 'shareEmailValue';
export const SET_SHARE_EMAIL_VALID = TRAVEL_UG_INSURANCE_FORM_SET_VALID + 'shareEmailValid';
export const transitionTravelInsuranceQuoteForm = {
    formValid: () => ({
        type: FORM_VALID_TRAVEL_UG_INSURANCE_FORM,
    }),
    formInvalid: () => ({
        type: FORM_INVALID_TRAVEL_UG_INSURANCE_FORM,
    }),
};

export const transitionShareQuoteForm = {
    formInvalid: () => ({
        type: FORM_VALID_TRAVEL_UG_INSURANCE_QUOTE_SHARE_FORM,
    }),
    formValid: () => ({
        type: FORM_INVALID_TRAVEL_UG_INSURANCE_QUOTE_SHARE_FORM,
    }),
};

// API Calls actions
export const API_PENDING_TRANSITION_TRAVEL_UG_INSURANCE_QUOTE_FORM = `${TRAVEL_UG_INSURANCE_FORM_SET_VALUE}/apiTransition/pending`;
export const API_SUCCESS_TRANSITION_TRAVEL_UG_INSURANCE_QUOTE_FORM = `${TRAVEL_UG_INSURANCE_FORM_SET_VALUE}/apiTransition/success`;
export const API_FAILURE_TRANSITION_TRAVEL_UG_INSURANCE_QUOTE_FORM = `${TRAVEL_UG_INSURANCE_FORM_SET_VALUE}/apiTransition/failure`;
export const API_INITIAL_TRANSITIONS_SHARE_QUOTE_FORM = `${TRAVEL_UG_INSURANCE_FORM_SET_VALUE}/shareQuote/apiTransition/initial`;
export const API_PENDING_TRANSITIONS_SHARE_QUOTE_FORM = `${TRAVEL_UG_INSURANCE_FORM_SET_VALUE}/shareQuote/apiTransition/pending`;
export const API_SUCCESS_TRANSITIONS_SHARE_QUOTE_FORM = `${TRAVEL_UG_INSURANCE_FORM_SET_VALUE}/shareQuote/apiTransition/success`;
export const API_FAILURE_TRANSITIONS_SHARE_QUOTE_FORM = `${TRAVEL_UG_INSURANCE_FORM_SET_VALUE}/shareQuote/apiTransition/failure`;
export const API_PRODUCTS_PENDING_TRANSITION = `${TRAVEL_UG_INSURANCE_FORM_SET_VALUE}/apiTransition/products/pending`;
export const API_PRODUCTS_SUCCESS_TRANSITION = `${TRAVEL_UG_INSURANCE_FORM_SET_VALUE}/apiTransition/products/success`;
export const API_PRODUCTS_FAILURE_TRANSITION = `${TRAVEL_UG_INSURANCE_FORM_SET_VALUE}/apiTransition/products/failure`;

export const apiTransitionTravelInsuranceQuoteForm = {
    pending: () => ({
        type: API_PENDING_TRANSITION_TRAVEL_UG_INSURANCE_QUOTE_FORM,
    }),
    success: () => ({
        type: API_SUCCESS_TRANSITION_TRAVEL_UG_INSURANCE_QUOTE_FORM,
    }),
    failure: () => ({
        type: API_FAILURE_TRANSITION_TRAVEL_UG_INSURANCE_QUOTE_FORM,
    }),
};

export const apiTransitionProducts = {
    pending: () => ({
        type: API_PRODUCTS_PENDING_TRANSITION,
    }),
    success: () => ({
        type: API_PRODUCTS_SUCCESS_TRANSITION,
    }),
    failure: () => ({
        type: API_PRODUCTS_FAILURE_TRANSITION,
    }),
};

export const apiTransitionShareQuoteForm = {
    initial: () => ({
        type: API_INITIAL_TRANSITIONS_SHARE_QUOTE_FORM,
    }),
    pending: () => ({
        type: API_PENDING_TRANSITIONS_SHARE_QUOTE_FORM,
    }),
    success: () => ({
        type: API_SUCCESS_TRANSITIONS_SHARE_QUOTE_FORM,
    }),
    failure: () => ({
        type: API_FAILURE_TRANSITIONS_SHARE_QUOTE_FORM,
    }),
};

// //calculated Data
export const COLLECT_TRAVEL_UG_INSURANCE_QUOTE_FORM_DATA =
    TRAVEL_UG_INSURANCE_FORM_SET_VALUE + 'collectTravelInsuranceQuoteData';
export const TRAVEL_UG_INSURANCE_ADD_COVER = TRAVEL_UG_INSURANCE_FORM_SET_VALUE + 'addCover';
export const CALCULATE_TRAVEL_UG_INSURANCE_PREMIUM_SUCCESS =
    TRAVEL_UG_INSURANCE_FORM_SET_VALUE + 'calculatePremiumSuccess';
export const CALCULATE_TRAVEL_UG_INSURANCE_PREMIUM_FAILURE = TRAVEL_UG_INSURANCE_FORM_SET_VALUE + 'failure';
export const COLLECT_SHARE_QUOTE_FORM_DATA = TRAVEL_UG_INSURANCE_FORM_SET_VALUE + 'collectShareQuoteFormData';
export const SHARE_MOTOR_INSURANCE_QUOTE_SUCCESS = TRAVEL_UG_INSURANCE_FORM_SET_VALUE + 'shareQuoteSuccess';
export const SHARE_MOTOR_INSURANCE_QUOTE_FAILURE = TRAVEL_UG_INSURANCE_FORM_SET_VALUE + 'shareQuoteFailure';
export const TRIGGER_FETCH_ALL_PRODUCTS = TRAVEL_UG_INSURANCE_FORM_SET_VALUE + 'fetchAllProducts';
export const FETCH_ALL_PRODUCTS_SUCCESS = TRAVEL_UG_INSURANCE_FORM + 'fetchAllProducts/success';
export const FETCH_ALL_PRODUCTS_FAILURE = TRAVEL_UG_INSURANCE_FORM + 'fetchAllProducts/failure';
export const FETCH_ALL_PRODUCTS_PENDING = TRAVEL_UG_INSURANCE_FORM + 'fetchAllProducts/pending';

export const CALCULATE_TRAVEL_UG_INSURANCE_ALTERNATE_PREMIUM_SUCCESS =
    TRAVEL_UG_INSURANCE_FORM_SET_VALUE + 'calculateAlternatePremiumSuccess';

export const collectTravelInsuranceQuoteData = () => ({
    type: COLLECT_TRAVEL_UG_INSURANCE_QUOTE_FORM_DATA,
});

// export const collectMotorInsuranceKeQuoteData = () => ({ type: COLLECT_KE_MOTOR_INSURANCE_QUOTE_FORM_DATA });
// export const collectThirdPartyQuoteData = () => ({ type: COLLECT_KE_THIRD_PARTY_DATA});
export const collectShareQuoteFormData = () => ({
    type: COLLECT_SHARE_QUOTE_FORM_DATA,
});

// export const submitMotorInsuranceQuoteSuccess = () => ({
// 	type: SUBMIT_MOTOR_INSURANCE_QUOTE_SUCCESS,
// 	value,
// });

export const shareQuoteSuccess = (value) => ({
    type: SHARE_MOTOR_INSURANCE_QUOTE_SUCCESS,
    value,
});

export const shareQuoteFailure = (error) => ({
    type: SHARE_MOTOR_INSURANCE_QUOTE_FAILURE,
    error,
});

export const calculateTravelInsurancePremiumSuccess = (value) => ({
    type: CALCULATE_TRAVEL_UG_INSURANCE_PREMIUM_SUCCESS,
    value,
});

export const calculateTravelInsuranceAlternatePremiumSuccess = (value) => ({
    type: CALCULATE_TRAVEL_UG_INSURANCE_ALTERNATE_PREMIUM_SUCCESS,
    value,
});

export const triggerFetchAllProducts = () => ({
    type: TRIGGER_FETCH_ALL_PRODUCTS,
});

export const fetchAllProductsSuccess = (value) => ({
    type: FETCH_ALL_PRODUCTS_SUCCESS,
    value,
});

export const fetchAllProductsFailure = (error) => ({
    type: FETCH_ALL_PRODUCTS_FAILURE,
    error,
});
export const fetchAllProductsPending = () => ({
    type: FETCH_ALL_PRODUCTS_PENDING,
});

// export const submitMotorInsuranceQuoteFailure = () => ({
// 	type: SUBMIT_MOTOR_INSURANCE_QUOTE_FAILURE,
// 	error,
// });

export const addCover = (value) => ({
    type: TRAVEL_UG_INSURANCE_ADD_COVER,
    value,
});

// Form values
export const SELECTED_FORM_SET_VALUE = TRAVEL_UG_INSURANCE_FORM_SET_VALUE + 'selectedForm';

export const SET_SHOW_TAGGING_ERROR_MODAL = TRAVEL_UG_INSURANCE_FORM_SET_VALUE + 'showTaggingErrorModal';
export const SET_TAGGING_ERROR_MESSAGE = TRAVEL_UG_INSURANCE_FORM_SET_VALUE + 'taggingErrorMessage';

export const SET_FULL_NAME_VALUE = TRAVEL_UG_INSURANCE_FORM_SET_VALUE + 'fullNameValue';
export const SET_FULL_NAME_VALID = TRAVEL_UG_INSURANCE_FORM_SET_VALID + 'fullNameValid';
export const ID_NUMBER_SET_VALUE = TRAVEL_UG_INSURANCE_FORM_SET_VALUE + 'idNumber';
export const ID_NUMBER_SET_VALID = TRAVEL_UG_INSURANCE_FORM_SET_VALID + 'idNumber';
export const PHONE_NUMBER_SET_VALUE = TRAVEL_UG_INSURANCE_FORM_SET_VALUE + 'phoneNumber';
export const PHONE_NUMBER_SET_VALID = TRAVEL_UG_INSURANCE_FORM_SET_VALID + 'phoneNumber';
export const EMAIL_SET_VALUE = TRAVEL_UG_INSURANCE_FORM_SET_VALUE + 'email';
export const EMAIL_SET_VALID = TRAVEL_UG_INSURANCE_FORM_SET_VALID + 'email';

//aml values
export const SET_FIRST_NAME_VALUE = TRAVEL_UG_INSURANCE_FORM_SET_VALUE + 'firstNameValue';
export const SET_FIRST_NAME_VALID = TRAVEL_UG_INSURANCE_FORM_SET_VALID + 'firstNameValid';
export const SET_MIDDLE_NAME_VALUE = TRAVEL_UG_INSURANCE_FORM_SET_VALUE + 'middleNameValue';
export const SET_MIDDLE_NAME_VALID = TRAVEL_UG_INSURANCE_FORM_SET_VALID + 'middleNameValid';
export const SET_LAST_NAME_VALUE = TRAVEL_UG_INSURANCE_FORM_SET_VALUE + 'lastNameValue';
export const SET_LAST_NAME_VALID = TRAVEL_UG_INSURANCE_FORM_SET_VALID + 'lastNameValid';

export const SET_TRIP_TYPE_VALUE = TRAVEL_UG_INSURANCE_FORM_SET_VALUE + 'tripTypeValue';
export const SET_TRIP_TYPE_VALID = TRAVEL_UG_INSURANCE_FORM_SET_VALID + 'tripTypeValid';
export const SET_COVER_FOR_VALUE = TRAVEL_UG_INSURANCE_FORM_SET_VALUE + 'coverForValue';
export const SET_COVER_FOR_VALID = TRAVEL_UG_INSURANCE_FORM_SET_VALID + 'coverForValid';
export const SET_AGE_VALUE = TRAVEL_UG_INSURANCE_FORM_SET_VALUE + 'ageValue';
export const SET_AGE_VALID = TRAVEL_UG_INSURANCE_FORM_SET_VALID + 'ageValid';

export const SET_DEPARTURE_COUNTRY_VALUE = TRAVEL_UG_INSURANCE_FORM_SET_VALUE + 'departureCountryValue';
export const SET_DEPARTURE_COUNTRY_VALID = TRAVEL_UG_INSURANCE_FORM_SET_VALID + 'departureCountryValid';
export const SET_DESTINATION_COUNTRY_VALUE = TRAVEL_UG_INSURANCE_FORM_SET_VALUE + 'destinationCountryValue';
export const SET_DESTINATION_COUNTRY_VALID = TRAVEL_UG_INSURANCE_FORM_SET_VALID + 'destinationCountryValid';
export const SET_DEPARTURE_DATE_VALUE = TRAVEL_UG_INSURANCE_FORM_SET_VALUE + 'departureDateValue';
export const SET_DEPARTURE_DATE_VALID = TRAVEL_UG_INSURANCE_FORM_SET_VALID + 'departureDateValid';

export const TRIGGER_GET_COUNTRIES = TRAVEL_UG_INSURANCE_FORM_SET_VALUE + 'fetch/countries';
export const SET_COUNTRIES_VALUE = TRAVEL_UG_INSURANCE_FORM_SET_VALUE + 'set/countries';
export const API_FAILURE_TRANSITION_COUNTRIES = TRAVEL_UG_INSURANCE_FORM_SET_VALUE + 'api/failure/countries';
export const API_SUCCESS_TRANSITION_COUNTRIES = TRAVEL_UG_INSURANCE_FORM_SET_VALUE + 'api/success/countries';
export const API_PENDING_TRANSITION_COUNTRIES = TRAVEL_UG_INSURANCE_FORM_SET_VALUE + 'api/pending/countries';
export const SET_DESTINATION_COUNTRIES_VALUE = TRAVEL_UG_INSURANCE_FORM_SET_VALUE + 'destinationCountries';
export const SET_DEPARTURE_COUNTRIES_VALUE = TRAVEL_UG_INSURANCE_FORM_SET_VALUE + 'departureCountries';

export const TRIGGER_GET_USD_RATE = TRAVEL_UG_INSURANCE_FORM_SET_VALUE + 'fetch/usdRate';
export const SET_USD_RATE_VALUE = TRAVEL_UG_INSURANCE_FORM_SET_VALUE + 'set/usdRate';
export const SET_UGX_PREMIUM_VALUE = TRAVEL_UG_INSURANCE_FORM_SET_VALUE + 'ugxPremium';
export const SET_ALTERNATE_UGX_PREMIUM_VALUE = TRAVEL_UG_INSURANCE_FORM_SET_VALUE + 'alternateUgxPremium';
export const API_FAILURE_TRANSITION_USD_RATE = TRAVEL_UG_INSURANCE_FORM_SET_VALUE + 'api/failure/usdRate';
export const API_SUCCESS_TRANSITION_USD_RATE = TRAVEL_UG_INSURANCE_FORM_SET_VALUE + 'api/success/usdRate';
export const API_PENDING_TRANSITION_USD_RATE = TRAVEL_UG_INSURANCE_FORM_SET_VALUE + 'api/pending/usdRate';

export const SET_RETURN_DATE_VALUE = TRAVEL_UG_INSURANCE_FORM_SET_VALUE + 'returnDateValue';
export const SET_RETURN_DATE_VALID = TRAVEL_UG_INSURANCE_FORM_SET_VALID + 'returnDateValid';

export const SET_DOB_VALUE = TRAVEL_UG_INSURANCE_FORM_SET_VALUE + 'DOBValue';
export const SET_DOB_VALID = TRAVEL_UG_INSURANCE_FORM_SET_VALID + 'DOBValid';

export const SET_NO_OF_TRAVELLERS_VALUE = TRAVEL_UG_INSURANCE_FORM_SET_VALUE + 'noOfTravellersValue';
export const SET_NO_OF_TRAVELLERS_VALID = TRAVEL_UG_INSURANCE_FORM_SET_VALID + 'noOfTravellersValid';

export const SET_NO_OF_MINORS_VALUE = TRAVEL_UG_INSURANCE_FORM_SET_VALUE + 'noOfMinorsValue';
export const SET_NO_OF_MINORS_VALID = TRAVEL_UG_INSURANCE_FORM_SET_VALID + 'noOfMinorsValid';

export const SET_TOTAL_NO_OF_TRAVELLERS_VALUE = TRAVEL_UG_INSURANCE_FORM_SET_VALUE + 'totalNoOfTravellersValue';

export const SET_SELECTED_COVER_VALUE = TRAVEL_UG_INSURANCE_FORM_SET_VALUE + 'selectTravelCover';
export const SET_SELECTED_COVER_VALID = TRAVEL_UG_INSURANCE_FORM_SET_VALID + 'selectTravelCover';

export const TRAVEL_UG_SIDEBAR_OPEN_VALUE = TRAVEL_UG_INSURANCE_FORM_SET_VALUE + 'sidebarOpen';
export const TRAVEL_UG_SHARE_QUOTE_VALUE = TRAVEL_UG_INSURANCE_FORM + 'shareQuote';

export const SET_NO_18_69_VALUE = TRAVEL_UG_INSURANCE_FORM_SET_VALUE + '18to69Value';
export const SET_NO_18_69_VALID = TRAVEL_UG_INSURANCE_FORM_SET_VALID + '18to69Valid';

export const SET_NO_70_75_VALUE = TRAVEL_UG_INSURANCE_FORM_SET_VALUE + '70to75Value';
export const SET_NO_70_75_VALID = TRAVEL_UG_INSURANCE_FORM_SET_VALID + '70to75Valid';

export const SET_NO_76_80_VALUE = TRAVEL_UG_INSURANCE_FORM_SET_VALUE + '76to80Value';
export const SET_NO_76_80_VALID = TRAVEL_UG_INSURANCE_FORM_SET_VALID + '76to80Valid';

export const SET_NO_81_85_VALUE = TRAVEL_UG_INSURANCE_FORM_SET_VALUE + '81to85Value';
export const SET_NO_81_85_VALID = TRAVEL_UG_INSURANCE_FORM_SET_VALID + '81to85Valid';

// action creators

export const setSelectedFormValue = (value) => ({
    type: SELECTED_FORM_SET_VALUE,
    value,
});

export const setShowTaggingErrorModal = (value) => ({
    type: SET_SHOW_TAGGING_ERROR_MODAL,
    value,
});

export const setTaggingErrorMessage = (value) => ({
    type: SET_TAGGING_ERROR_MESSAGE,
    value,
});

export const setFullNameValue = (value) => ({
    type: SET_FULL_NAME_VALUE,
    value,
});

export const setFullNameValid = (error) => ({
    type: SET_FULL_NAME_VALID,
    error,
});

export const setFirstNameValue = (value) => ({
    type: SET_FIRST_NAME_VALUE,
    value,
});

export const setFirstNameValid = (error) => ({
    type: SET_FIRST_NAME_VALID,
    error,
});

export const setLastNameValue = (value) => ({
    type: SET_LAST_NAME_VALUE,
    value,
});

export const setLastNameValid = (error) => ({
    type: SET_LAST_NAME_VALID,
    error,
});

export const setMiddleNameValue = (value) => ({
    type: SET_MIDDLE_NAME_VALUE,
    value,
});

export const setMiddleNameValid = (error) => ({
    type: SET_MIDDLE_NAME_VALID,
    error,
});

export const setIdNumberValue = (value) => ({
    type: ID_NUMBER_SET_VALUE,
    value,
});

export const setIdNumberValid = (error) => ({
    type: ID_NUMBER_SET_VALID,
    error,
});

export const setPhoneNumberValue = (value) => ({
    type: PHONE_NUMBER_SET_VALUE,
    value,
});
export const setPhoneNumberValid = (error) => ({
    type: PHONE_NUMBER_SET_VALID,
    error,
});

export const setEmailValue = (value) => ({
    type: EMAIL_SET_VALUE,
    value,
});
export const setEmailValid = (error) => ({
    type: EMAIL_SET_VALID,
    error,
});

export const setTripTypeValue = (value) => ({
    type: SET_TRIP_TYPE_VALUE,
    value,
});

export const setTripTypeValid = (error) => ({
    type: SET_TRIP_TYPE_VALID,
    error,
});

export const setCoverForValue = (value) => ({
    type: SET_COVER_FOR_VALUE,
    value,
});

export const setCoverForValid = (error) => ({
    type: SET_COVER_FOR_VALID,
    error,
});

export const setAgeValue = (value) => ({
    type: SET_AGE_VALUE,
    value,
});

export const setAgeValid = (error) => ({
    type: SET_AGE_VALID,
    error,
});

export const setDepartureCountryValue = (value) => ({
    type: SET_DEPARTURE_COUNTRY_VALUE,
    value,
});

export const setDepartureCountryValid = (error) => ({
    type: SET_DEPARTURE_COUNTRY_VALID,
    error,
});

export const setDestinationCountryValue = (value) => ({
    type: SET_DESTINATION_COUNTRY_VALUE,
    value,
});

export const setDestinationCountryValid = (error) => ({
    type: SET_DESTINATION_COUNTRY_VALID,
    error,
});

export const setDepartureDateValue = (value) => ({
    type: SET_DEPARTURE_DATE_VALUE,
    value,
});

export const setDepartureDateValid = (error) => ({
    type: SET_DEPARTURE_DATE_VALID,
    error,
});

export const setDobDateValue = (value) => ({
    type: SET_DOB_VALUE,
    value,
});

export const setDobDateValid = (error) => ({
    type: SET_DOB_VALID,
    error,
});

export const setReturnDateValue = (value) => ({
    type: SET_RETURN_DATE_VALUE,
    value,
});

export const setReturnDateValid = (error) => ({
    type: SET_RETURN_DATE_VALID,
    error,
});

export const setNoOfTravellersValue = (value) => ({
    type: SET_NO_OF_TRAVELLERS_VALUE,
    value,
});

export const setNoOfTravellersValid = (error) => ({
    type: SET_NO_OF_TRAVELLERS_VALID,
    error,
});

export const setNoOfMinorsValue = (value) => ({
    type: SET_NO_OF_MINORS_VALUE,
    value,
});

export const setNoOfMinorsValid = (error) => ({
    type: SET_NO_OF_MINORS_VALID,
    error,
});

export const setNo18to69Value = (value) => ({
    type: SET_NO_18_69_VALUE,
    value,
});

export const setNo18to69Valid = (error) => ({
    type: SET_NO_18_69_VALID,
    error,
});

export const setNo70to75Value = (value) => ({
    type: SET_NO_70_75_VALUE,
    value,
});

export const setNo70to75Valid = (error) => ({
    type: SET_NO_70_75_VALID,
    error,
});

export const setNo76to80Value = (value) => ({
    type: SET_NO_76_80_VALUE,
    value,
});

export const setNo76to80Valid = (error) => ({
    type: SET_NO_76_80_VALID,
    error,
});

export const setNo81to85Value = (value) => ({
    type: SET_NO_81_85_VALUE,
    value,
});

export const setNo81to85Valid = (error) => ({
    type: SET_NO_81_85_VALID,
    error,
});

export const setTotalNoOfTravellersValue = (value) => ({
    type: SET_TOTAL_NO_OF_TRAVELLERS_VALUE,
    value,
});

export const initializeQuoteForm = () => ({
    type: REINITIALIZE,
});

export const setShareEmailValue = (value) => ({
    type: SET_SHARE_EMAIL_VALUE,
    value,
});

export const setShareEmailValid = (error) => ({
    type: SET_SHARE_EMAIL_VALID,
    error,
});

export const SUBMIT_TRAVEL_UG_QUOTE_FORM_DATA = TRAVEL_UG_INSURANCE_FORM_SET_VALUE + 'submitTravelUgQuoteFormData';

export const submitTravelUgQuoteFormData = () => ({
    type: SUBMIT_TRAVEL_UG_QUOTE_FORM_DATA,
});

export const UPDATE_TRAVEL_UG_QUOTE_FORM_DATA = TRAVEL_UG_INSURANCE_FORM_SET_VALUE + 'updateTravelUgQuoteFormData';

export const updateTravelUgQuoteFormData = () => ({
    type: UPDATE_TRAVEL_UG_QUOTE_FORM_DATA,
});

export const SET_CUSTOMER_ID = TRAVEL_UG_INSURANCE_FORM_SET_VALUE + 'customerId';

export const setCustomerIdValue = (value) => ({
    type: SET_CUSTOMER_ID,
    value,
});

export const apiTransitionCountries = {
    pending: () => ({
        type: API_PENDING_TRANSITION_COUNTRIES,
    }),
    success: () => ({
        type: API_SUCCESS_TRANSITION_COUNTRIES,
    }),
    failure: () => ({
        type: API_FAILURE_TRANSITION_COUNTRIES,
    }),
};

export const triggerGetCountries = () => ({
    type: TRIGGER_GET_COUNTRIES,
});

export const setCountriesList = (value) => ({
    type: SET_COUNTRIES_VALUE,
    value,
});

export const setDestinationCountriesValue = (value) => ({
    type: SET_DESTINATION_COUNTRIES_VALUE,
    value,
});

export const setDepartureCountriesValue = (value) => ({
    type: SET_DEPARTURE_COUNTRIES_VALUE,
    value,
});

export const apiTransitionUsdRate = {
    pending: () => ({
        type: API_PENDING_TRANSITION_USD_RATE,
    }),
    success: () => ({
        type: API_SUCCESS_TRANSITION_USD_RATE,
    }),
    failure: () => ({
        type: API_FAILURE_TRANSITION_USD_RATE,
    }),
};

export const triggerGetUsdRate = () => ({
    type: TRIGGER_GET_USD_RATE,
});

export const setUsdRate = (value) => ({
    type: SET_USD_RATE_VALUE,
    value,
});

export const setUgxPremium = (value) => ({
    type: SET_UGX_PREMIUM_VALUE,
    value,
});

export const setAlternateUgxPremium = (value) => ({
    type: SET_ALTERNATE_UGX_PREMIUM_VALUE,
    value,
});

export const TOKEN_IS_EXPIRED = 'travelUg/expiredAuth';

export const setExpiredAuth = (value) => ({
    type: TOKEN_IS_EXPIRED,
    value,
});

export const setSideBarOpen = (value) => ({ type: TRAVEL_UG_SIDEBAR_OPEN_VALUE, value });
export const setShowShareModal = (value) => ({ type: TRAVEL_UG_SHARE_QUOTE_VALUE, value });

export const setSelectedCoverValue = (value) => ({ type: SET_SELECTED_COVER_VALUE, value });
export const setSelectedCoverValid = (error) => ({ type: SET_SELECTED_COVER_VALID, error });

export const SET_ENABLE_DOWNLOAD_QUOTE_VALUE = TRAVEL_UG_INSURANCE_FORM_SET_VALUE + 'enableDownloadQuote';

export const setEnableDownloadQuote = (value) => ({
    type: SET_ENABLE_DOWNLOAD_QUOTE_VALUE,
    value,
});

export const SET_SHARE_EMAIL_BASE_64_VALUE = TRAVEL_UG_INSURANCE_FORM_SET_VALUE + 'shareEmailBase64Value';

export const setShareEmailBase64Value = (value) => ({
    type: SET_SHARE_EMAIL_BASE_64_VALUE,
    value,
});
